import api from '../../../App/socket';

export const getLeadsStatus = () => api.send(
    {
        api: 'db',
        model: 'Lead_status',
        action: 'Read',
        options: {
            attributes: 'all',
            include:
                    {
                        model: 'Lead_status',
                        path: 'children',
                        attributes: 'all',
                    },
        },
    },
).then((response) => {
    const tree = [];
    const uid = {};
    const wait_uid = {};

    response.options.forEach((_doc) => {
        _doc.children = [];
        uid[_doc._id] = _doc;

        if (_doc.parent) {
            if (!uid[_doc.parent]) {
                if (!wait_uid[_doc.parent]) wait_uid[_doc.parent] = [];
                wait_uid[_doc.parent].push(_doc);
            } else {
                uid[_doc.parent].children.push(_doc);
            }
        } else {
            tree.push(_doc);
        }

        if (wait_uid[_doc._id]) {
            _doc.children = wait_uid[_doc._id];
            delete wait_uid[_doc._id];
        }
    });

    return tree;
}).catch(error => error);



// WEBPACK FOOTER //
// ./src/modules/Leads/Lead_profile/requests/get_leads_status_request.js